import { Component, CSP_NONCE, inject, OnInit } from '@angular/core';
import { ThemingService } from './core/theming/theming.service';
import { filter, map, Observable, startWith } from 'rxjs';
import { EventType, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { EXTERNAL_ID_STORAGE, TOKEN_STORAGE } from './core/init/init.component';
import { AsyncPipe } from '@angular/common';
import { HeaderComponent } from './graphic/header/header.component';
import { AppConfig } from './app.config';

interface Window {
  __cspNonce: string;
}

@Component({
  selector: 'fol-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [AsyncPipe, RouterOutlet, HeaderComponent]
})
export class AppComponent implements OnInit {
  private readonly themingService: ThemingService = inject(ThemingService);
  private readonly router: Router = inject(Router);
  private readonly appConfig = inject(AppConfig);
  private readonly cspNonce = inject(CSP_NONCE);

  step$: Observable<{ isOnSummaryPage: boolean }>;
  token = localStorage.getItem(TOKEN_STORAGE);
  externalId = localStorage.getItem(EXTERNAL_ID_STORAGE);
  isOnInitPageAlready = /init/.test(window.location.href);

  currentTheming$ = this.themingService.getCurrentTheming().pipe(map(theming => theming.isThemingSet));

  constructor() {
    (window as unknown as Window).__cspNonce = this.cspNonce ?? '';
    const mobisub = document.createElement('script');
    mobisub.setAttribute('nonce', this.cspNonce ?? '');
    mobisub.setAttribute('src', this.appConfig.mobiSubUrl + '/mobi-sub.js');
    mobisub.setAttribute('type', 'module');
    mobisub.setAttribute('async', 'true');
    mobisub.setAttribute('name', 'mobi-sub');
    document.getElementsByTagName('head')[0].appendChild(mobisub);

    this.step$ = this.router.events.pipe(filter(event => event.type === EventType.NavigationEnd)).pipe(
      map(navigationEnd => (navigationEnd as NavigationEnd).urlAfterRedirects === '/step'),
      startWith(false),
      map(isOnSummaryPage => {
        return { isOnSummaryPage };
      })
    );
  }

  ngOnInit(): void {
    if (this.isOnInitPageAlready) {
      return;
    }
    this.router.navigate(['']);
  }
}
